import { Component } from '@angular/core';

import { ActivitiesBaseComponent } from '../../activities.base.service';

@Component({
  selector: 'app-activities-shared',
  templateUrl: './activities-shared.component.html',
  styleUrls: ['./activities-shared.component.scss'],
})
export class ActivitiesSharedComponent extends ActivitiesBaseComponent {}
